<template>
  <v-menu
    bottom
    left
    min-width="120"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        x-small
        icon
        outlined
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list
      dense
      class="pa-0"
    >
      <v-list-item
        v-if="active"
        @click="inActivate()"
      >
        <v-list-item-title>
          <v-icon
            small
            left
            color="error"
          >
            mdi-lightbulb-off
          </v-icon>
          In-activate
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-else
        @click="activate()"
      >
        <v-list-item-title>
          <v-icon
            small
            left
            color="success"
          >
            mdi-lightbulb-on
          </v-icon>
          Activate
        </v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item v-if="false">
        <v-list-item-title>
          <change-password
            reset-password
            :user-id="userId"
          >
            <v-icon
              small
              left
              color="success"
            >
              mdi-lock-reset
            </v-icon>
            Reset Password
          </change-password>
        </v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item
        v-if="!verified"
        @click="ReSendVerifMail()"
      >
        <v-list-item-title>
          <v-icon
            small
            left
            color="primary"
          >
            mdi-email-alert
          </v-icon>
          Resend Verification Email
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { failure } from "@/mixins/common";
import ChangePassword from "@/components/user/password/changePassword";
export default {
  name: "UserOptions",
  components: {
    ChangePassword
  },
  mixins: [failure],
  props: {
    userId: {
      type: Number,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    verified:{
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    inActivate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to inactivate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/users/${this.userId}/inactivate`)
            .then(
              function (data) {
                this.handleSuccess(data.body);
              },
              function (failure) {
                this.handleFailure(failure);
              }
            );
        });
    },
    activate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to activate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/users/${this.userId}/activate`)
            .then(
              function (data) {
                this.handleSuccess(data.body);
              },
              function (failure) {
                this.handleFailure(failure);
              }
            );
        });
    },
    ReSendVerifMail() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to re send verification mail ?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/users/${this.userId}/reInvite`)
            .then(
              function (data) {
                this.handleSuccess(data.body);
              },
              function (failure) {
                this.handleFailure(failure);
              }
            );
        });
    },
    handleSuccess: function (response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
      this.$emit("reload");
    }
  }
};
</script>
